import * as z from 'zod/v4';

export const multiForecastOutcomeSchema = z.coerce.number().int().nonnegative().brand<'MultiForecastOutcome'>();
export type MultiForecastOutcome = z.infer<typeof multiForecastOutcomeSchema>;
